import { Observable } from 'rxjs'
import { Address } from '@spartacus/core'

export abstract class MbUserAddressAdapter {

  abstract loadAll(userId: string): Observable<Address[]>
}
